import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';
import ReminderForm from './pages/ReminderForm';
import Profile from './pages/Profile';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';
import AdminUsers from './pages/admin/Users';
import AdminUserDetail from './pages/admin/UserDetail';
import AdminReport from './pages/admin/Report';

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/login" element={<Layout showAds={false}><Login /></Layout>} />
      <Route path="/register" element={<Layout showAds={false}><Register /></Layout>} />
      <Route path="/forgot-password" element={<Layout showAds={false}><ForgotPassword /></Layout>} />
      <Route path="/reset-password/:token" element={<Layout showAds={false}><ResetPassword /></Layout>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
      <Route path="/terms" element={<Layout><Terms /></Layout>} />
      <Route path="/blog" element={<Layout><Blog /></Layout>} />
      <Route path="/blog/:slug" element={<Layout><BlogArticle /></Layout>} />
      <Route path="/verify-email/:token" element={<VerifyEmail />} />

      {/* Protected user routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>
      } />
      <Route path="/reminders/new" element={
        <ProtectedRoute><Layout><ReminderForm /></Layout></ProtectedRoute>
      } />
      <Route path="/reminders/:id/edit" element={
        <ProtectedRoute><Layout><ReminderForm /></Layout></ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>
      } />

      {/* Admin routes */}
      <Route path="/admin/users" element={
        <ProtectedRoute adminOnly><Layout><AdminUsers /></Layout></ProtectedRoute>
      } />
      <Route path="/admin/users/:id" element={
        <ProtectedRoute adminOnly><Layout><AdminUserDetail /></Layout></ProtectedRoute>
      } />
      <Route path="/admin/report" element={
        <ProtectedRoute adminOnly><Layout><AdminReport /></Layout></ProtectedRoute>
      } />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
